















import { LabelQualityGoal } from '@/interfaces/types/QualityGoal';
import LabelQualityGoalItem from './LabelQualityGoalItem.vue';
import Vue, { PropType } from 'vue';

export default Vue.extend({
  components: { LabelQualityGoalItem },
  props: {
    list: {
      type: Array as PropType<Array<LabelQualityGoal>>,
    },
    isAllPostable: {
      type: Boolean,
    },
  },
  data(): {
    isPostableList: boolean[];
    localIsAllPostable: boolean;
  } {
    return {
      isPostableList: [],
      localIsAllPostable: this.isAllPostable,
    };
  },
  watch: {
    isPostableList: {
      handler: function (valList: boolean[]) {
        const postable = valList.every((val) => val === true);
        this.localIsAllPostable = postable;
        this.$emit('update:isAllPostable', postable);
      },
      deep: true,
    },
    'list.length': function (newVal, oldVal) {
      if (newVal > oldVal) {
        this.isPostableList.push(false);
      }
    },
  },
  methods: {
    deleteItem(idx: number) {
      this.list.splice(idx, 1);
      this.isPostableList.splice(idx, 1);
    },
  },
});
